import { authHeader, handleResponse } from './helper';
import config from '../config';

export const getPrestationByAdmissionPatient = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/orderDetails/getPrestationsBy`);
  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
};
